import React from "react";
import Filter from "../../filter/Filter";
import classes from "./Products.module.css";
import ProductsList from "./ProductsList";

const fetchConfig = async () => {
  try {
    const response = await fetch('/config.json');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Erro ao buscar o config:", error);
    return null;
  }
};
const config = await fetchConfig();

const fetchStrings = async () => {
  try {
    const response = await fetch(`${config.url}/catalogo/${config.diretorio}/mensagens.json?v=${crypto.randomUUID()}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Erro ao buscar os produtos:", error);
    return [];
  }
};
const strings = await fetchStrings();

const Products = () => {
  return (
    <div className="container">
      <main className={classes.main}>
        <p className={classes.navCatalogo}>{strings.pagecatalog}</p>
        <Filter />
        <ProductsList />
      </main>
    </div>
  );
};

export default Products;
